import React from "react";

function TestLogin() {
  return (
    <>
      <div className="account-pages pt-sm-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card overflow-hidden">
                <div
                  className="bg-primary bg-soft"
                  style={{ backgroundColor: "rgb(37 137 177 / 25%)!important" }}
                >
                  <div className="row">
                    <div className="col-8">
                      <div className="text-primary p-4">
                        <a
                          href="javascript:void(0)"
                          className=""
                          style={{
                            color: "#dc4237",
                            fontFamily: "oswald",
                            fontSize: "18px",
                          }}
                        >
                          ENGINEERING PROJECTS{" "}
                          <span style={{ color: "#014d87" }}>(INDIA) LTD</span>
                        </a>
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p style={{ color: "#000000" }}>
                          Sign in to continue to <strong>EPIL</strong>{" "}
                          Administration Control Panel.
                        </p>
                      </div>
                    </div>
                    <div className="col-4 align-self-end">
                      <img
                        src="assets/images/profile-img.png"
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className="auth-logo">
                    <a href="index.php" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src="assets/images/admin-icon-new.png"
                            alt=""
                            className="rounded-circle"
                            height="70"
                          />
                        </span>
                      </div>
                    </a>

                    <a href="index.php" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src="assets/images/admin-icon-new.png"
                            alt=""
                            className="rounded-circle"
                            height="70"
                          />
                        </span>
                      </div>
                    </a>
                  </div>
                  <div className="p-2">
                    <form
                      className="form-horizontal"
                      action=""
                      method="POST"
                      name="loginForm"
                      id="loginForm"
                    >
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label">
                          Username
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="username"
                          required
                          id="username"
                          placeholder="Enter username"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="input-group auth-pass-inputgroup">
                          <input
                            type="password"
                            className="form-control"
                            name="password"
                            required
                            placeholder="Enter password"
                            aria-label="Password"
                            aria-describedby="password-addon"
                          />
                          <button
                            className="btn btn-light "
                            type="button"
                            id="password-addon"
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </button>
                        </div>
                      </div>
                      <div className="field-row" id="captchaDiv">
                        <div
                          className="form-group"
                          id="refreshArea"
                          style={{ alignItems: "center" }}
                        >
                          <p
                            className="security-pin"
                            style={{ marginRight: "5px" }}
                            id="randomOTP"
                          >
                            {" "}
                          </p>
                          <input
                            type="hidden"
                            name="captcha"
                            id="captcha"
                            value="<?=$randomOTP?>"
                          />
                        </div>
                        <div className="col-lg-2">
                          <button
                            type="button"
                            className="captcha"
                            name="refbutton"
                            id="refbutton"
                          >
                            <img
                              src="<?=URL?>assets/img/RefreshCaptcha.png"
                              style={{ width: "25px", height: "25px" }}
                            />
                          </button>
                        </div>

                        <div className="field-row">
                          <input
                            type="text"
                            className="captchabox"
                            name="CaptchaText"
                            id="CaptchaText"
                            autoComplete="off"
                            placeholder="Enter Captcha"
                          />
                        </div>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="remember-check"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="remember-check"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary waves-effect waves-light"
                          type="submit"
                          style={{
                            backgroundColor: "#023f74",
                            bordercolor: "#023f74",
                          }}
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <a
                          href="auth-recoverpw.php"
                          style={{ color: "#d92828 !important" }}
                          className="text-muted"
                        >
                          <i className="mdi mdi-lock me-1"></i> Forgot your
                          password?
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <div>
                  <p>
                    <a href="<?=URL?>" target="_blank">
                      <img
                        src="assets/images/EPIL.png"
                        style={{ width: "265px", marginBottom: "12px" }}
                      />
                    </a>
                    <br /> Crafted with{" "}
                    <i className="bx bx-heart" style={{ color: "red" }}></i> by{" "}
                    <a
                      href="https://valueinnovationlabs.com/"
                      style={{ color: "#023f74" }}
                      title="Technology company with products in HRMS AI and Blockchain Noida, Delhi India"
                    >
                      Value Innovation Labs (P) Ltd.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
}

export default TestLogin;
